import React, { useContext, useEffect, useRef, useState } from "react";
import Layout from "../../components/Layout";
import DashboardList from "./DashboardList";
import { Chart } from "./Chart";
import { useDispatch, useSelector } from "react-redux";
import Dashreport from "../../components/SharedComponets/Dashreport";
import BreakModal from "./BreakModal";
import { breakOut, checkIn, checkOut, getCurrentAttendance, getMemberMetric } from "../../services";
import moment from "moment";
import { setCurruntAttendance } from "../../store/slices/payrollSlice";
import _ from "lodash";
import Timer from "./Timer";
import { breaks, transformedBreaks } from "../../utils/Helpers";
import Modals from "../../components/SharedComponets/Modals";
import { toast, ToastContainer } from "react-toastify";
import { AppContext } from "../../utils/AppContext";
import { createPortal } from "react-dom";

export default function Dashboard() {
  const dispatch = useDispatch();
  const { Invoice, AttendanceSocket, BreakSocket } = useContext(AppContext);
  const userProfile = useSelector((state) => state.user.userinfo);
  const cureentAttendence = useSelector((state) => state.payroll.cureentAttendence);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [metrics, setMetrics] = useState(false);
  const [isCheckOutModalOpen, setIsCheckOutModalOpen] = useState(false);
  const [isLoadingCheckIn, setIsLoadingCheckIn] = useState(false);
  const [isLoadingCheckOut, setIsLoadingCheckOut] = useState(false);
  const [isLoadingBreakOut, setIsLoadingBreakOut] = useState(false);
  const [isCheckinDisabled, setIsCheckinDisabled] = useState(true);
  const [isProfilePopup, setIsProfilePopup] = useState(false);
  const [errMsg, setErrMsg] = useState({
    err: false,
    msg: "",
    color: "warning",
  });
  const [showProfileModal, setShowProfileModal] = useState(false);


  const fetchCurruntAttendance = async () => {
    setErrMsg({ err: false, msg: "", color: "red" });

    try {
      const response = await getCurrentAttendance();
      dispatch(setCurruntAttendance(response.data.Result || null));
    } catch (err) {
      console.error("Error fetching CurruntAttendance:", err);
    }
  };

  const fetchMetrics = async () => {
    try {
      const response = await getMemberMetric(
        userProfile.Id,

      );
      setMetrics(response?.data?.Result);
    } catch (err) {
      console.error("Error fetching metrics:", err);
    }
  };


  const isTabHidden = useRef(false);

  const handleWindowFocus = () => {
    if (document.visibilityState === 'visible' && isTabHidden.current) {
      fetchMetrics();
      fetchCurruntAttendance();
    }
    isTabHidden.current = document.visibilityState === 'hidden';
  };

  useEffect(() => {
    fetchMetrics();
    fetchCurruntAttendance();
    document.addEventListener('visibilitychange', handleWindowFocus);
    return () => {
      document.removeEventListener('visibilitychange', handleWindowFocus);
    };
  }, [Invoice, AttendanceSocket]);

  const handleCheckIn = async () => {
    setIsLoadingCheckIn(true);
    try {
      await checkIn();
      await fetchCurruntAttendance();
      toast.success("Your timer has started!", {
        containerId: 'toaster',
        position: "top-right",
        className: "dark:bg-[rgb(193,236,193)] bg-green-800 font-medium dark:text-gray-800 text-gray-800",
        icon: false,
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        hideProgressBar: false,
        style: {
          borderBottom: "2px solid gray",
          padding: "2px 6px",
          fontSize: '1.4rem',
          minHeight: "60px"
        },
        progressStyle: {
          backgroundColor: "green",
        },
      });

    } catch (err) {
      console.error("Error during check-in:", err);
    } finally {
      setIsLoadingCheckIn(false);
    }
  };

  const openCheckOutModal = () => setIsCheckOutModalOpen(true);
  const closeCheckOutModal = () => setIsCheckOutModalOpen(false);

  const confirmCheckOut = async () => {
    setIsLoadingCheckOut(true);
    try {
      if (!_.isEmpty(cureentAttendence?.BreakStartTime)) {
        await breakOut();
      }
      await checkOut();
      await fetchCurruntAttendance();
      toast.info("Your shift has ended", {
        containerId: 'toaster',
        position: "top-right",
        className: "dark:bg-[rgb(225,188,184)] bg-red-800 text-base dark:text-gray-900 text-gray-800",
        icon: false,
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        hideProgressBar: false,
        style: {
          borderBottom: "2px solid gray",
          padding: "2px 6px",
          fontSize: '1.4rem',
          minHeight: "60px"

        },
        progressStyle: {
          backgroundColor: "red",
        },
      });

    } catch (err) {
      console.error("Error during check-out:", err);
    } finally {
      setIsLoadingCheckOut(false);
      closeCheckOutModal();
    }
  };

  const handleBreakOut = async () => {
    setIsLoadingBreakOut(true);
    try {
      await breakOut();
      await fetchCurruntAttendance();
      toast.info("Break has ended. Welcome back!", {
        containerId: "toaster",
        position: "top-right",
        className: "dark:bg-[rgb(175,204,221)] bg-blue-800 text-base dark:text-gray-800 text-gray-800",
        icon: false,
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        hideProgressBar: false,
        style: {
          borderBottom: "2px solid gray",
          padding: "2px 6px",
          fontSize: '1.4rem',
          minHeight: "60px"
        },
        progressStyle: {
          backgroundColor: "blue",
        },

      });
    } catch (err) {
      console.error("Error during break-out:", err);
    } finally {
      setIsLoadingBreakOut(false);
    }
  };

  const handleBreakClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const allReasons = Object.values(breaks).flatMap((breakType) =>
    breakType.reasons.map((reason) => ({
      id: reason.id,
      label: reason.label,
    }))
  );

  const getBreakReasonLabel = (breakReasonId) => {
    const foundReason = allReasons.find(
      (reason) => reason.id === breakReasonId
    );
    return foundReason ? foundReason.label : "Unknown";
  };

  const toggleProfile = () => {
    setIsProfilePopup((prev) => !prev);
    if (!isProfilePopup) {
      document.body.classList.add("active-modal");
    } else {
      document.body.classList.remove("active-modal");
    }
  };


  useEffect(() => {
    let intervalId = null;

    const checkTime = () => {
      if (!userProfile.ShiftStart) {
        return;
      }
      const currentTime = moment.utc().startOf("second"); // Truncate to seconds
      const today = moment.utc().startOf("day");
      const shiftStartTime = moment.utc(today).set({
        hour: parseInt(userProfile?.ShiftStart?.split(":")[0], 10),
        minute: parseInt(userProfile?.ShiftStart?.split(":")[1], 10),
        second: parseInt(userProfile?.ShiftStart?.split(":")[2], 10),
      });


      setIsCheckinDisabled(currentTime.isBefore(shiftStartTime));
    };

    // Initial check
    checkTime();

    if (isCheckinDisabled) {
      // Calculate delay to synchronize with the start of the next minute
      const now = moment.utc();
      const delay = 60000 - (now.seconds() * 1000 + now.milliseconds());

      // Set a timeout to start the interval at the next full minute
      const timeoutId = setTimeout(() => {
        checkTime(); // Immediate check at the start of the next minute
        intervalId = setInterval(checkTime, 60000); // Run every minute
      }, delay);

      // Cleanup timeout and interval when component unmounts or isCheckinDisabled changes
      return () => {
        clearTimeout(timeoutId);
        clearInterval(intervalId);
      };
    }

    // Cleanup the interval if isCheckinDisabled is false
    return () => clearInterval(intervalId);
  }, [userProfile.ShiftStart, isCheckinDisabled]);

  useEffect(() => {
    if (BreakSocket?.BreakReason === 9) {
      // Call the fetch function
      fetchCurruntAttendance();
      const breakReasonName = getBreakReasonLabel(BreakSocket?.BreakReason);
      // Show the toast message
      toast.success(`Your ${breakReasonName} break has started!`, {
        containerId: 'toaster',
        position: 'top-right',
        className: 'dark:bg-[rgb(193,236,193)] bg-green-800 text-base dark:text-gray-800 text-gray-800',
        icon: false,
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        hideProgressBar: false,
        style: {
          borderBottom: '2px solid gray',
          padding: '2px 6px',
          fontSize: '1.4rem',
          minHeight: '60px',
        },
        progressStyle: {
          backgroundColor: 'green',
        },
      });
    }
  }, [BreakSocket?.BreakReason]);


  return (
    <Layout>
      <div className="xl:flex xl:items-start xl:space-x-3 space-y-3 xl:space-y-0  ">
        <div className="xl:w-1/3 relative group/dashboard-profile xl:flex xl:flex-col">
          <div
            className="absolute -inset-[4px] bg-gradient-to-r from-blue-600/40 via-indigo-600/40 to-blue-600/40 rounded-2xl blur-sm opacity-50 group-hover/dashboard-profile:opacity-80 transition duration-500 pointer-events-none"
            aria-hidden="true"
          />
          <div className="relative flex flex-col h-[346px] rounded-2xl border-2 border-blue-500/20 dark:border-blue-400/20 bg-white/70 dark:bg-black/40 backdrop-blur-3xl shadow-[0_15px_35px_-10px_rgba(0,0,0,0.4)] px-3 py-4 dark:text-gray-100">
          <div className="flex flex-col items-center">
            <img
              className="border-4 border-white dark:border-gray-800 w-[90px] h-[90px] -mt-8 rounded-full cursor-pointer"
              src={userProfile.PhotoPath}
              alt={userProfile.MemberName}
              onClick={() => setShowProfileModal(true)}
            />
            {showProfileModal && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
                onClick={() => setShowProfileModal(false)}
              >
                <div
                  className="bg-white dark:bg-gray-900 rounded-xl p-6 shadow-lg flex flex-col items-center relative animate-fade-in"
                  onClick={e => e.stopPropagation()}
                >
                  <button
                    className="absolute top-2 right-2 text-2xl font-bold text-gray-500 hover:text-gray-800"
                    onClick={() => setShowProfileModal(false)}
                  >
                    &times;
                  </button>
                  <img
                    src={userProfile.PhotoPath}
                    alt={userProfile.MemberName}
                    className="w-[300px] h-[300px] rounded-full object-cover border-4 border-gray-300 shadow-lg"
                  />
                  <div className="mt-4 text-xl font-semibold text-gray-800 dark:text-gray-100 text-center">
                    {userProfile.MemberName}
                  </div>
                </div>
              </div>
            )}
            <div className="text-center w-full">
              <h2 className="text-2xl font-bold mt-2 text-center">{userProfile.MemberName}</h2>
              <p className="font-semibold text-gray-600 text-center dark:text-gray-500 leading-none">
                {userProfile.Designation}
              </p>
             
              <button
                onClick={toggleProfile}
                className="btn-modal text-center text-blue-700 font-bold mt-2"
              >
                View Profile
              </button>

              {isProfilePopup && createPortal(
                <Modals Member={userProfile} toggleProfile={toggleProfile} />,
                document.body
              )}
              {errMsg.err && <p style={{ color: errMsg.color }}>{errMsg.msg}</p>}

              <div className="mt-2.5 text-center ">
                {cureentAttendence.BreakStartTime && (
                  <p
                    className={`absolute font-semibold text-3xl left-0 right-0 py-1 ${cureentAttendence.BreakReason === 9 ? 'bg-[#ffee58] text-black' : 'bg-[#908e8ec7] dark:bg-[#000000c7]'
                      }`}
                  >
                    {transformedBreaks[cureentAttendence?.BreakType]} - {getBreakReasonLabel(cureentAttendence?.BreakReason)}
                  </p>
                )}

                <p className="text-5xl font-bold">

                  <Timer cureentAttendence={cureentAttendence} />
                </p>
                <p className="font-normal text-sm">{moment().format('dddd, DD MMMM YYYY')}</p>
              </div>
              <div className="mt-4 text-center">
                {!_.isEmpty(cureentAttendence) && (
                  <>

                    {isCheckinDisabled ?
                      (
                        <p className="text-blue-800 dark:text-blue-300 text-xl text-center mt-3 font-semibold">
                          <span>Check-in time is in the {moment.utc(userProfile.ShiftStart, "h:mm A").local().format("h:mm A")}</span>
                        </p>
                      )
                      :
                      <>
                        {_.isEmpty(cureentAttendence?.CheckInTime) ? (
                          <>
                            <p className="md:hidden text-amber-700 dark:text-amber-200/90 text-sm sm:text-base text-center mt-3 font-semibold leading-snug px-1">
                              Check-in is not allowed on mobile. Please use a desktop browser to check in.
                            </p>
                            <button
                              type="button"
                              className="hidden md:flex text-[26px] tracking-wide h-16 font-medium w-full rounded-xl disabled:opacity-55 bg-green-500/10 border-2 border-green-500/25 text-green-900 dark:text-green-100 backdrop-blur-3xl shadow-[0_6px_18px_-10px_rgba(34,197,94,0.35)] hover:shadow-[0_10px_30px_-16px_rgba(34,197,94,0.55)] hover:bg-green-500/15 hover:border-green-500/35 transition-all duration-200 items-center justify-center active:scale-[0.98]"
                              onClick={handleCheckIn}
                              disabled={isLoadingCheckIn || isCheckinDisabled}
                            >
                              {isLoadingCheckIn ? (
                                <svg
                                  aria-hidden="true"
                                  className="w-6 h-6 animate-spin dark:text-gray-400 fill-blue-600 dark:fill-white"
                                  viewBox="0 0 100 101"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill"
                                  />
                                </svg>
                              ) : (
                                "Check In"
                              )}
                            </button>
                          </>
                        ) : (
                          <>
                            {_.isEmpty(cureentAttendence?.CheckOutTime) ? (
                              <div className="grid grid-cols-2 text-center gap-3">
                                <button
                                  className="py-3.5 text-[26px] tracking-wide font-medium w-full rounded-xl disabled:opacity-55 bg-red-500/10 border-2 border-red-500/25 text-red-900 dark:text-red-100 backdrop-blur-3xl shadow-[0_6px_18px_-10px_rgba(244,63,94,0.35)] hover:shadow-[0_10px_30px_-16px_rgba(244,63,94,0.55)] hover:bg-red-500/15 hover:border-red-500/35 transition-all duration-200 flex items-center justify-center active:scale-[0.98]"
                                  onClick={openCheckOutModal}
                                >
                                  Check-Out
                                </button>
                                {_.isEmpty(cureentAttendence?.BreakStartTime) ? (
                                  <button
                                    className="py-3.5 text-[26px] tracking-wide font-medium w-full rounded-xl disabled:opacity-55 bg-blue-500/10 border-2 border-blue-500/30 text-blue-900 dark:text-blue-100 backdrop-blur-3xl shadow-[0_6px_18px_-10px_rgba(59,130,246,0.35)] hover:shadow-[0_10px_30px_-16px_rgba(59,130,246,0.55)] hover:bg-blue-500/15 hover:border-blue-500/45 transition-all duration-200 flex items-center justify-center active:scale-[0.98]"
                                    onClick={handleBreakClick}

                                  >
                                    Break In

                                  </button>
                                ) : (
                                  <button
                                    className="py-3.5 text-[26px] tracking-wide font-medium w-full rounded-xl disabled:opacity-55 bg-blue-500/10 border-2 border-blue-500/30 text-blue-900 dark:text-blue-100 backdrop-blur-3xl shadow-[0_6px_18px_-10px_rgba(59,130,246,0.35)] hover:shadow-[0_10px_30px_-16px_rgba(59,130,246,0.55)] hover:bg-blue-500/15 hover:border-blue-500/45 transition-all duration-200 flex items-center justify-center active:scale-[0.98]"
                                    onClick={handleBreakOut}
                                    disabled={isLoadingBreakOut}

                                  >
                                    {isLoadingBreakOut ? (
                                      <svg
                                        aria-hidden="true"
                                        className="w-6 h-6 animate-spin dark:text-gray-400 fill-blue-600 dark:fill-white"
                                        viewBox="0 0 100 101"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                          fill="currentFill"
                                        />
                                      </svg>
                                    ) : (
                                      "Break Out"
                                    )}
                                  </button>
                                )}

                              </div>
                            ) : (
                              <p className="text-red-600 text-xl text-center mt-3 font-semibold">
                                <span>Your shift has ended</span>
                              </p>
                            )}
                          </>
                        )}
                      </>}
                  </>
                )}


              </div>
            </div>
          </div>
          </div>
        </div>
        <div className="xl:flex xl:items-start xl:space-x-3 xl:w-2/3 space-y-3 xl:space-y-0 xl:min-w-0">
          <div className="relative shrink-0 min-w-0 group/dashboard-analysis xl:flex xl:flex-col">
            <div
              className="absolute -inset-[1px] bg-gradient-to-r from-blue-600/40 via-indigo-600/40 to-blue-600/40 rounded-2xl blur-sm opacity-50 group-hover/dashboard-analysis:opacity-80 transition duration-500 pointer-events-none"
              aria-hidden="true"
            />
            <div className="relative flex flex-col min-h-[calc(21rem+10px)] px-5 py-4 rounded-2xl border-2 border-blue-500/20 dark:border-blue-400/20 bg-white/70 dark:bg-black/40 backdrop-blur-3xl shadow-[0_15px_35px_-10px_rgba(0,0,0,0.4)] font-medium dark:text-gray-100">
              <p className="text-gray-800 dark:text-gray-400 font-bold shrink-0">Analysis</p>
              <div className="flex flex-1 flex-col justify-center min-h-0">
                <Chart metrics={metrics} dashboardEmbed />
              </div>
            </div>
          </div>
          <div className="min-w-0 flex-1 xl:min-w-0 xl:flex xl:flex-col">
            <Dashreport metrics={metrics} setMetrics={setMetrics} dashboardRow />
          </div>
        </div>
      </div>

      {/* Admin: Live Status table moved to DashboardList sidebar */}

      <DashboardList />

      <BreakModal
        isOpen={isModalOpen}
        onClose={closeModal}
        fetchCurruntAttendance={fetchCurruntAttendance}
      />
      {isCheckOutModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
          <div className="bg-white/70 dark:bg-black/40 backdrop-blur-3xl p-4 scale-125 rounded-2xl border-2 border-blue-500/20 dark:border-blue-400/20 shadow-[0_20px_70px_-25px_rgba(0,0,0,0.6)]">
            <h2 className="text-lg font-bold mb-3 text-gray-900 dark:text-white">Confirm Check Out</h2>
            <p className="mb-3 text-sm font-medium text-gray-900 dark:text-white">Are you sure you want to check out?</p>
            <div className="flex justify-end space-x-4">
              <button
                className="font-medium tracking-wide rounded-xl bg-rose-600 hover:bg-rose-700 text-white border border-rose-400/30 shadow-[0_4px_12px_-2px_rgba(225,29,72,0.4)] hover:shadow-[0_6px_16px_-2px_rgba(225,29,72,0.6)] transition-all duration-300 flex items-center justify-center disabled:opacity-55 active:scale-[0.98]"
                style={{ width: "140px", height: "40px" }}
                onClick={confirmCheckOut}
                disabled={isLoadingCheckOut}
              >
                {isLoadingCheckOut ? (
                  <svg
                    aria-hidden="true"
                    className="w-6 h-6 animate-spin dark:text-gray-400 fill-blue-600 dark:fill-white"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                ) : (
                  "Yes"
                )}
              </button>
              <button
                className="bg-white/10 border-2 border-blue-500/15 text-gray-900 dark:text-gray-100 py-2 px-4 rounded-xl hover:bg-white/[0.14] hover:border-blue-500/35 transition-all duration-200 flex items-center justify-center disabled:opacity-55"
                style={{ width: "140px", height: "40px" }}
                onClick={closeCheckOutModal}
              >
                No
              </button>
            </div>
          </div>
        </div>

      )}
      <ToastContainer containerId="toaster" className="foo" style={{ width: "480px" }} />

    </Layout >
  );
}
